import React, { useContext } from 'react';
import ThemePanel from '../panels/ThemePanel';
import TextFieldsPanel from '../panels/TextFieldsPanel';
import ButtonStylingPanel from '../panels/ButtonStylingPanel';
import TextFieldStylingPanel from '../panels/TextFieldStylingPanel';
import LeadingQuestionPanel from '../panels/LeadingQuestionPanel';
import CountdownPanel from '../panels/CountdownPanel';
import { ListWrapper } from '../Steps/components';
import UrlTargetPanel from '../panels/UrlTargetPanel';
import WebformOptionsPanel from '../panels/WebformOptionsPanel';
import PhoneNumberPanel from '../panels/PhoneNumberPanel';
import SocialProfilePanel from '../panels/SocialProfilePanel';
import ImagePanel from '../panels/ImagePanel';
import HeadlinePanel from '../panels/HeadlinePanel';
import CTAPanel from '../panels/CTAPanel';
import NoThanksPanel from '../panels/NoThanksPanel';
import Subheadline1Panel from '../panels/Subheadline1Panel';
import Subheadline2Panel from '../panels/Subheadline2Panel';
import InlineStylingPanel from '../panels/InlineStylingPanel';
import FormBuilderPanel from '../panels/FormBuilderPanel';
import FormStylingPanel from '../panels/FormStylingPanel';
import { EditorContext } from '../../../utils/contexts';

export default function InlineDesign() {
  const { settings } = useContext(EditorContext);
  const isForms =
    settings.element_subtype === 'forms' ||
    settings.subtype === 'forms' ||
    !!settings.form_type ||
    (Array.isArray(settings.form_questions) && settings.form_questions.length > 0);

  if (isForms) {
    return (
      <ListWrapper>
        <ThemePanel />
        <InlineStylingPanel />
        <Subheadline1Panel />
        <FormStylingPanel />
        <FormBuilderPanel />
        <ImagePanel />
        <ButtonStylingPanel />
      </ListWrapper>
    );
  }

  return (
    <ListWrapper>
      <ThemePanel />
      <InlineStylingPanel />
      <HeadlinePanel />
      <Subheadline1Panel />
      <Subheadline2Panel />
      <TextFieldsPanel />
      <TextFieldStylingPanel />
      <PhoneNumberPanel />
      <SocialProfilePanel />
      <WebformOptionsPanel />
      <ImagePanel />
      <UrlTargetPanel />
      <CTAPanel />
      <ButtonStylingPanel />
      <NoThanksPanel />
      <LeadingQuestionPanel />
      <CountdownPanel />
    </ListWrapper>
  );
}
